export default __webpack_public_path__ + "static/media/item-5.b4c755bc.png";